import React, { Component } from "react";
import QrReader from "react-qr-scanner";
import Back from "../../components/goBack";
import BackDrop from "../../components/Backdrop/Backdrop";

export default class Qrcode extends Component {
  constructor(props) {
    super(props);
    this.state = {
      delay: 100,
      result: null,
      isLoading: true,
      camera: "rear",
    };

    this.handleScan = this.handleScan.bind(this);
  }
  handleScan(data) {
    this.setState({
      result: data,
    });
  }
  handleError(err) {
    console.error(err);
  }

  onLoad = () => {
    this.setState({ isLoading: false });
  };

  goBack = () => {
    this.setState({ result: null });
    localStorage.BRHMQRCODE = null;
  };

  render() {
    if (this.state.result !== null) {
      localStorage.BRHMQRCODE = this.state.result;
    }

    let loading = (
      <BackDrop>
        <p>loading...</p>
      </BackDrop>
    );

    // console.log(this.state);

    return (
      <div style={styles.container}>
        {this.state.isLoading ? loading : null}
        {this.state.result !== null ? (
          <Back clickHandler={this.goBack} />
        ) : null}

        {this.state.result === null ? (
          <div style={styles.qrcontainer}>
            <QrReader
              delay={this.state.delay}
              style={styles.previewStyle}
              onError={this.handleError}
              onScan={this.handleScan}
              onLoad={this.onLoad}
              facingMode={this.state.camera}
              //   maxImageSize={3000}
            />

            <em>Place Qr Code Under Camera </em>
            <div style={styles.cameraButtonDiv}>
              <button
                style={styles.cameraButton}
                onClick={() => this.setState({ camera: "rear" })}
              >
                Back Camera
              </button>
              <button
                style={styles.cameraButton}
                onClick={() => this.setState({ camera: "front" })}
              >
                Front Camera
              </button>
            </div>
          </div>
        ) : (
          <div style={styles.result}>
            <div style={{ wordWrap: "break-word" }}>
              <h4>Benue State Internal Revenue Service</h4>
              <p style={{ width: "95%" }}> {localStorage.BRHMQRCODE}</p>
            </div>
            <div style={{ marginBottom: 10 }}>
              <button
                style={{
                  width: "150px",
                  height: "60px",
                  borderRadius: "10px",
                  backgroundColor: "green",
                }}
              >
                <a
                  href={localStorage.BRHMQRCODE}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    color: "white",
                    fontSize: "12px",
                    textDecoration: "none",
                  }}
                >
                  View Document
                </a>
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: 50,
    justifyContent: "space-evenly",
    height: "100vh",
    textAlign: "center",
  },
  result: {
    display: "flex",
    width: "80%",
    height: "50%",
    backgroundColor: "white",
    boxShadow: "2px 2px 2px 2px #eee",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "6px",
    borderRadius: "10px",
  },
  qrcontainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "space-around",
  },
  previewStyle: {
    height: 500,
    width: 320,
    objectFit: "fill",
    paddingTop: 0,
    marginBottom: 20,
  },
  cameraButtonDiv: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
    paddingTop: 20,
  },
  cameraButton: {},
};
